var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.707 40.293a1 1 0 0 0-1.414 1.414l1.414-1.414ZM35 53l-.707.707a1 1 0 0 0 1.414 0L35 53Zm24.707-23.293a1 1 0 0 0-1.414-1.414l1.414 1.414ZM80 41c0 21.54-17.46 39-39 39v2c22.644 0 41-18.356 41-41h-2ZM41 80C19.46 80 2 62.54 2 41H0c0 22.644 18.356 41 41 41v-2ZM2 41C2 19.46 19.46 2 41 2V0C18.356 0 0 18.356 0 41h2ZM41 2c21.54 0 39 17.46 39 39h2C82 18.356 63.644 0 41 0v2ZM22.293 41.707l12 12 1.414-1.414-12-12-1.414 1.414Zm13.414 12 24-24-1.414-1.414-24 24 1.414 1.414Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.77e3774a.svg";
export { ForwardRef as ReactComponent };